import React, { useEffect, useState } from "react"
import * as styles from "./DropdownGallery.module.css"
import useSolutionData, { getFrontmatter } from "../utils/useSolutionData"
import classNames from "classnames"
import { Link } from "gatsby"
import RightArrowSVG from "../../../../images/decorative/right-arrow.inline.svg"

type DropdownGalleryProps = {
  pages: Array<string>
}

type FrontmatterType = {
  image: string
  svg: string
  title: string
  description: string
  link: string
}

const DropdownGallery = ({ pages }: DropdownGalleryProps) => {
  const [dataPages, setDataPages] = useState<Array<FrontmatterType>>([
    { image: "", svg: "", title: "", description: "", link: "" },
  ])
  const [activePage, setActivePage] = useState(0)

  const solutionsData = useSolutionData()

  useEffect(() => {
    const getData = pages.map(page => {
      if (page.split("/")[1] === "solutions")
        return getFrontmatter(solutionsData, page)
      else return { image: "", svg: "", title: "", description: "", link: "" }
    })
    setDataPages(getData)
  }, [pages])

  const { image, svg, title, description, link } = dataPages[activePage]

  return (
    <div className={styles.container}>
      {/* Image */}
      <div className={styles.imageContent}>
        <img src={image} alt={title} />
      </div>

      {/* List */}
      <ul className={styles.listContent}>
        {dataPages.map(({ title }, index) => (
          <li
            className={classNames(styles.item, {
              [styles.active]: activePage === index,
            })}
            onClick={() => setActivePage(index)}
          >
            {title.split(" ")[1]}
            <div className={styles.box}>
              {/* Image Mobile */}
              <div className={styles.imageMobile}>
                <img src={image} alt={title} />
              </div>

              <img src={svg} alt={title} />
              <h4>{title.split(" ").slice(0, 2).join(" ")}</h4>
              <p>
                {description.length > 170
                  ? `${description.slice(0, 166)}...`
                  : description}
              </p>
              <Link to={link}>
                Read More <RightArrowSVG />
              </Link>
            </div>
          </li>
        ))}
      </ul>
    </div>
  )
}

export default DropdownGallery
